import type { RefObject } from "react";
import type { GetHomeDataResult, MembershipProduct, SpaceProfile } from "../SpaceType";
import { spaceHomeLayoutCssVars } from "./Config";
import { SpaceHomeInfoSection } from "./SpaceHomeInfoSection";
import { SpaceHomeProductPreview } from "./SpaceHomeProductPreview";
import { SpaceHomeSubscribeCards } from "./SpaceHomeSubscribeCards";
import { WeworkHomePopupHost } from "../../wework_service/WeworkHomePopupHost";
import "./SpaceHomeStyle.css";

export function SpaceHomePage(props: {
  spaceId: string;
  profile: SpaceProfile | null;
  homeData: GetHomeDataResult | null;
  membershipProducts: MembershipProduct[];
  isLoggedIn: boolean;
  favorStatus: 0 | 1;
  subscribeSectionHintRef: RefObject<HTMLParagraphElement>;
  onLoginRequest: () => void;
  onFollow: () => void;
  onRequestUnfollow: () => void;
}) {
  const {
    spaceId,
    profile,
    homeData,
    membershipProducts,
    isLoggedIn,
    favorStatus,
    subscribeSectionHintRef,
    onLoginRequest,
    onFollow,
    onRequestUnfollow,
  } = props;

  return (
    <div className="space-home-page" style={spaceHomeLayoutCssVars()}>
      <WeworkHomePopupHost spaceId={spaceId} />
      {profile ? (
        <SpaceHomeInfoSection
          profile={profile}
          isLoggedIn={isLoggedIn}
          favorStatus={favorStatus}
          onLoginRequest={onLoginRequest}
          onFollow={onFollow}
          onRequestUnfollow={onRequestUnfollow}
        >
          <SpaceHomeProductPreview
            spaceId={spaceId}
            data={homeData}
            membershipProducts={membershipProducts}
            isLoggedIn={isLoggedIn}
            onLoginRequest={onLoginRequest}
          />
          <SpaceHomeSubscribeCards
            spaceId={spaceId}
            products={membershipProducts}
            isLoggedIn={isLoggedIn}
            sectionHintRef={subscribeSectionHintRef}
            onLoginRequest={onLoginRequest}
          />
        </SpaceHomeInfoSection>
      ) : null}
    </div>
  );
}
